
import React, { lazy, Suspense } from 'react';
import { Routes, BrowserRouter, Route } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';

// Components
import Header from 'components/commonComponents/Header';
import Footer from 'components/commonComponents/Footer';
import RequireAuth from './RequireAuth';

// The home page ships with the shell; every other page is its own chunk so a visitor
// only downloads what they open (ViewTrip alone pulls in the PDF/Word export libraries).
import HomePage from 'components/pages/HomePage';

const Trips = lazy(() => import('components/pages/Trips'));
const SpecialEditions = lazy(() => import('components/pages/SpecialEditions'));
const EmiratesEdition = lazy(() => import('components/pages/SpecialEditions/Emirates'));
const GoetheEdition = lazy(() => import('components/pages/SpecialEditions/Goethe'));
const AddTrip = lazy(() => import('components/pages/Trips/AddTrip'));
const ViewTrip = lazy(() => import('components/pages/Trips/ViewTrip'));
const ViewArticle = lazy(() => import('components/pages/Articles/ViewArticle'));
const AddArticle = lazy(() => import('components/pages/Articles/AddArticle'));
const Settings = lazy(() => import('components/pages/Settings'));
const Articles = lazy(() => import('components/pages/Articles'));
const Contact = lazy(() => import('components/pages/Contact'));
const About = lazy(() => import('components/pages/About'));
const AppDetail = lazy(() => import('components/pages/About/AppDetail'));
const Founder = lazy(() => import('components/pages/About/Founder'));
const Maps = lazy(() => import('components/pages/Maps'));
const Subscription = lazy(() => import('components/pages/Subscription'));
const SubscribePayment = lazy(() => import('components/pages/SubscribePayment'));
const Etisalat = lazy(() => import('components/pages/Etisalat'));
const Awards = lazy(() => import('components/pages/Awards'));
const AwardsAll = lazy(() => import('components/pages/Awards/AwardsAll'));
const PrivacyPolicy = lazy(() => import('components/pages/StaticPages/PrivacyPolicy'));
const BookView = lazy(() => import('components/pages/Awards/BookView'));
const BookMap = lazy(() => import('components/pages/Awards/Maps'));
const Search = lazy(() => import('components/pages/Search'));
const SearchInterMediate = lazy(() => import('components/pages/Search/SearchInterMediate'));
const HelpAndSupport = lazy(() => import('components/pages/HelpAndSupport'));
const ChatFAQ = lazy(() => import('components/pages/ChatFAQ'));
const Sitemap = lazy(() => import('components/pages/Sitemap'));
const HealthCheck = lazy(() => import('components/pages/HealthCheck'));
const Thanks = lazy(() => import('components/pages/Thanks'));
const FileUpload = lazy(() => import('components/pages/FileUpload'));

const PageLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', padding: '120px 0', minHeight: '60vh' }}>
    <CircularProgress />
  </div>
);

const AppRouter = () => {
  return (
    <div>
      <BrowserRouter >
        <div>
          <Header />
          <div className="content-wrapper">
            <Suspense fallback={<PageLoader />}>
              <Routes>

                <Route path="/" element={<HomePage />} />
                <Route path="*" element={<HomePage />} />

                <Route path="/trips/special" element={<SpecialEditions />} />
                <Route path="/special/emirates" element={<EmiratesEdition />} />
                <Route path="/special/goethe/*" element={<GoetheEdition />} />
                <Route path="/trips/:tripType" element={<Trips />} />
                <Route path="/trip/:tripId" element={<ViewTrip />} />
                <Route path="/add-trip" element={<RequireAuth><AddTrip /></RequireAuth>} />
                <Route path="/edit-trip/:tripId" element={<RequireAuth><AddTrip /></RequireAuth>} />

                <Route path="/article/:tripId/:articleId" element={<ViewArticle />} />
                <Route path="/add-article/:tripId" element={<RequireAuth><AddArticle /></RequireAuth>} />
                <Route path="/edit-article/:tripId/:articleId" element={<RequireAuth><AddArticle /></RequireAuth>} />
                <Route path="/articles/:tripId" element={<Articles />} />

                <Route path="/map/:tripId" element={<Maps />} />

                <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/the-founder" element={<Founder />} />
                <Route path="/about/app/:appId" element={<AppDetail />} />

                <Route path="/subscribe" element={<Subscription />} />

                <Route path="/subscription-payment/:subId" element={<RequireAuth><SubscribePayment /></RequireAuth>} />
                <Route path="/etisalat/:subId" element={<RequireAuth><Etisalat /></RequireAuth>} />

                <Route path="/awards" element={<Awards />} />
                <Route path="/awards/list/:type/:typeId" element={<AwardsAll />} />
                <Route path="/book/:bookId" element={<BookView />} />
                <Route path="/book/map" element={<BookMap />} />

                <Route path="/privacy" element={<PrivacyPolicy id='59' />} />
                <Route path="/cookie" element={<PrivacyPolicy id='46' />} />
                <Route path="/terms" element={<PrivacyPolicy id='47' />} />

                <Route path='/help-and-support' element={<HelpAndSupport />} />
                <Route path='/chatFAQ' element={<ChatFAQ />} />

                <Route path='/search' element={<Search />} />
                <Route path='/search/articles/:tripId' element={<SearchInterMediate />} />

                <Route path='/sitemap' element={<Sitemap />} />
                <Route path="/thanks" element={<Thanks />} />
                <Route path="/create-modal" element={<FileUpload />} />
                <Route path="/healthcheck" element={<HealthCheck />} />

              </Routes>
            </Suspense>
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </div>
  );
};
export default AppRouter;
